export default __webpack_public_path__ + "static/media/pw-templates-list.960a693b.jpg";